// export const DEFAULT_SIGNATORY_COUNTRY = "United Arab Emirates";
export const UAE = "AE";
export const MAX_PO_BOX_LENGTH = 10;
